import { DataResult } from '@progress/kendo-data-query';
import { Action, createReducer, on } from '@ngrx/store';
import { IntegrationDashboardActions } from './integration-dashboard.actions';
import { FetchArgs } from 'src/app/shared/models/core';
import { DefaultDateRange } from '../dashboard-health/dashboard-health.component';
import { IntegrationStatus } from '../../enums/integration-status.enum';

export const defaultDashboardFetchArgs: FetchArgs = {
    filter: {
        eventDateUtcFrom: new Date(Date.now() - DefaultDateRange * 24 * 60 * 60 * 1000).toISOString(),
        eventDateUtcTo: new Date().toISOString()
    },
    sort: { field: 'eventDateUtc', dir: 'desc' },
    skip: 0,
    pageSize: 50
};

export const MAX_PAGE_SIZE = 500;

export interface IntegrationDashboardState {
    args: FetchArgs;
    integrationEventLogList: DataResult;
    isLoading: boolean;
    isRunningPipeline: boolean;
}

export const integrationDashboardInitialState: IntegrationDashboardState = {
    integrationEventLogList: {
        data: [],
        total: 0
    },
    isLoading: false,
    isRunningPipeline: false,
    args: defaultDashboardFetchArgs
};

export const integrationDashboardReducer = (
    reducerState: IntegrationDashboardState,
    reducerAction: Action
): IntegrationDashboardState => {
    return createReducer(
        integrationDashboardInitialState,
        on(
            IntegrationDashboardActions.getAllIntegrationEventLogs,
            (state): IntegrationDashboardState => ({
                ...state,
                isLoading: true
            })
        ),
        on(
            IntegrationDashboardActions.setAllIntegrationEventLogs,
            (state, action): IntegrationDashboardState => ({
                ...state,
                integrationEventLogList: action.integrationEventLogList,
                isLoading: false
            })
        ),
        on(
            IntegrationDashboardActions.integrationArtifactDownloaded,
            (state): IntegrationDashboardState => ({
                ...state
            })
        ),
        on(
            IntegrationDashboardActions.setArgs,
            (state, action): IntegrationDashboardState => ({
                ...state,
                args: {
                    ...action.args,
                    pageSize:
                        action.args.pageSize > MAX_PAGE_SIZE || !action.args.pageSize
                            ? MAX_PAGE_SIZE
                            : action.args.pageSize,
                    skip: action.args.skip || 0,
                    sort: action.args.sort || defaultDashboardFetchArgs.sort
                }
            })
        ),
        on(
            IntegrationDashboardActions.runDOPsPipeline,
            (state): IntegrationDashboardState => ({
                ...state,
                isRunningPipeline: true
            })
        ),
        on(
            IntegrationDashboardActions.runDOPsPipelineSuccess,
            (state): IntegrationDashboardState => ({
                ...state,
                isRunningPipeline: false
            })
        ),
        on(
            IntegrationDashboardActions.runDOPsPipelineFailure,
            (state): IntegrationDashboardState => ({
                ...state,
                isRunningPipeline: false
            })
        ),
        on(
            IntegrationDashboardActions.setStatus,
            (state, action): IntegrationDashboardState => ({
                ...state,
                args: {
                    ...state.args,
                    filter: {
                        ...state.args.filter,
                        // Remove spaces to support conversion of "Partial Success" status to "PartialSuccess"
                        status: [IntegrationStatus[action.status.replace(/\s+/g, '') as keyof typeof IntegrationStatus]]
                    }
                }
            })
        )
    )(reducerState, reducerAction);
};
